import PreorderProduct from '../../models/PreorderProduct'
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'


export interface PreorderProductListState extends PaginatedApiState {
  preorderProducts?: PreorderProduct[] 
}

export const emptyPreorderProduct: PreorderProduct[] = [{
    subgroupId: 0,
    code: '',
    description: '',
    products: []
}]



const PreorderProductList = (state: PreorderProductListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    case 'PREORDER_PRODUCT_LIST_CLEAR':
          return { ...state, preorderProducts: emptyPreorderProduct }
    default:
      return requestReducer<PreorderProductListState>('PREORDER_PRODUCT_LIST')(state, action)
  }
}

export default PreorderProductList
